export const getIsPrerenderUserAgent = () => {
  return navigator != null && /prerender/i.test(navigator.userAgent);
};
export const getIsEcosystemSocialScreenshotUserAgent = () => {
  return navigator != null && /Ecosystem-Social-Screenshot/.test(navigator.userAgent);
};
export const getIsChromeUserAgent = () => {
  return navigator != null && /chrome/i.test(navigator.userAgent);
};